<h2>{{ title }} - {{ model.Name }}</h2>
<hr />

<div class="divrel">
  <tabset #tabs>
    <tab heading="General">
      <br />
      <form
        (ngSubmit)="onSubmit()"
        #editFacilityForm="ngForm"
        class="editForm"
        novalidate
        [ngBusy]="busy"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Name</label>
              <input type="text" #name class="form-control" name="Name" [(ngModel)]="model.Name" />
              <app-tooltip [form]="'system.feeSchedule'" [uid]="'Name'"></app-tooltip>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label">Active On</label>
              <app-datetime
                name="ActiveOnDateTime"
                [(ngModel)]="model.ActiveOnDateTime"
                [options]="this.util.getDefaultDateOptions(false)"
                [utc]="true"
              ></app-datetime>
              <app-tooltip [form]="'system.feeSchedule'" [uid]="'ActiveOnDateTime'"></app-tooltip>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label">Expires On</label>
              <app-datetime
                name="ExpiresOnDateTime"
                [(ngModel)]="model.ExpiresOnDateTime"
                [options]="this.util.getDefaultDateOptions(false)"
                [utc]="true"
              ></app-datetime>
              <app-tooltip [form]="'system.feeSchedule'" [uid]="'ExpiresOnDateTime'"></app-tooltip>
            </div>
          </div>
        </div>

        <hr />

        <div class="row">
          <button class="btn btn-default pull-right" type="button" (click)="backToList()">
            Back to list
          </button>
          <button type="submit" class="btn btn-success pull-right" style="margin-right: 15px">
            Save
          </button>
        </div>
      </form>
    </tab>

    <tab heading="Procedure Codes" [disabled]="!this.model.Id">
      <app-fee-schedule-edit-codes
        *ngIf="tabs.tabs[1].active === true"
        [feeScheduleId]="feeScheduleId"
      ></app-fee-schedule-edit-codes>

      <hr />

      <div class="row">
        <button class="btn btn-default pull-right" type="button" (click)="backToList()">
          Back to list
        </button>
      </div>
    </tab>

    <tab heading="Revenue Codes" [disabled]="!this.model.Id">
      <app-fee-schedule-edit-revenue-codes
        *ngIf="tabs.tabs[2].active === true"
        [feeScheduleId]="feeScheduleId"
      ></app-fee-schedule-edit-revenue-codes>

      <hr />

      <div class="row">
        <button class="btn btn-default pull-right" type="button" (click)="backToList()">
          Back to list
        </button>
      </div>
    </tab>
  </tabset>
</div>
